/**
 * Checks if the text contains at lease one US phone numbers
 * @param text - The text to check if it contains a phone number.
 * @returns true if the text contains a phone number, false otherwise.
 */
export const PHONE_NUMBER_REGEX =
  /\b(1[-.\s()]?)?(\d{3})[-.\s()]*(\d{3})[-.\s()]*(\d{4})\b/g;

export const hasPhoneNumber = (text: string): boolean =>
  PHONE_NUMBER_REGEX.test(text);
